import React, { Component } from 'react'
import Header from '@/components/Header'
import MetaDetail from '../../components/_common/MetaDetail'
import Form from "@/components/_common/Form";
import TextField from "@/components/_common/Form/inputs/TextField";
import Dob from "@/components/_common/Form/inputs/Dob";
import Select from "@/components/_common/Form/inputs/Select";
//import Checkbox from "#/components/_common/Form/inputs/Checkbox";
import tracking from '../../utils/tracking'
import './terms-and-conditions.scss'



class TermsAndConditionsPage extends Component {

	


	componentDidMount() {
		tracking.pageView('/terms-and-conditions')
	}

	

	

	  
	render() {

		
		return (
			<div className='terms-and-conditions' >
				<Header />
				<h2>TERMS AND CONDITIONS FOR GUINNESS OPEN GATE BREWERY – LOREM IPSUM COMPETITION  </h2>
				<ol className='terms-and-conditions-container'>
					<li>
					The Competition is not open to Guinness Open Gate Brewery (the Promoter, details of which are set out below) employees or contractors, their immediate family members or staff of any associated companies, including promotional partners or anyone professionally involved with this Competition. 
					</li>
					<li>
					Entry into this Competition shall be deemed to be a full and unconditional acceptance by the entrant of these Terms and Conditions. 
					</li>
					<li>
					Failure to adhere to these Terms and Conditions may result in disqualification from the Competition and forfeiture of the Prize. This shall be at the sole discretion of Guinness Open Gate Brewery and no correspondence will be entered into. 
					</li>
					<li>
					No purchase is necessary. 
					</li>
					<li>
					Entrants must be 18 years or older and resident in Ireland. 
					</li>
					<li>
					Offer is valid from [Xday] [X] [X] 2020 at 12:01 GMT closing on [Xday] [X] [X]  2020 at 11:59 GMT. Winner(s) will be contacted on [Xday] [X] [X] 2020. 
					</li>
					<li>
					To enter the competition entrants must visit Guinness Open Gate Brewery website, fill out their name, DOB, enter a comment on our competition webpage on https://www.guinnessopengate.com/ answering question of ‘what is your favourite food and beer pairing’ 
					</li>
					<li>
					The Prize constitutes 5 winners offering Lorem Ipsum. 	
					</li>
					<li>
					The winners will be chosen on [Xday] [X] [X] 2020. The winners will be chosen by a panel of two people from all the validly submitted entries received before the closing date. The panel will comprise two staff members from Guinness Open Gate Brewery (whose decisions are final in all respects). The winners will be the entrants that provides the most interesting responses when entering the Promotion, by responding on the unique webpage on https://www.guinnessopengate.com/. In the event of any dispute regarding the rules, conduct or the result, the panel’s decision will be final and no correspondence will be entered into. 
					</li>
					<li>
					The winners will be contacted by the Guinness Open Gate Brewery team. The Guinness Open Gate Brewery team will attempt contact with the selected winner a maximum of 2 times using their specified contact details from 10am-5pm GMT on [Xday] [X] [X] 2020. If no return contact is made by the winner by 5pm on [Xday] [X] [X] 2020, a different winner will be selected, and the original winner will forfeit their prize. This will continue until each winner accepts the prize within the timeframe above, with all subsequent winners forfeiting their prize if they do not respond within the specified timeframe. 	
					</li>
					<li>
					The Prize is offered as stated and is non-transferable. No cash alternative, or alternative prize to the stated Prize shall be offered or made available, however Guinness Open Gate Brewery reserves the right to replace the Prize with an alternative prize of equal or greater value. 
					</li>
					<li>
					A representative from Guinness Open Gate Brewery team will arrange postage of the prize to winner(s). 
					</li>
					<li>
					Adult verification is required at delivery 
					</li>
					<li>
					No other correspondence will be entered into concerning the result and Guinness Open Gate Brewery’s decision is final. 
					</li>
					<li>
					The winner(s) may be required to participate in reasonable publicity connected with the Promotion. The winner(s) and the winner’s guest(s) accept that the Promoter will have the right, without additional payment or permission, to use his/her name, for the purposes of announcing the winner and for related promotional purposes, including the winner’s answer and reason in order to promote the Guinness Open Gate Brewery. 
					</li>
					<li>
					By participating in the Promotion, the entrants license and grant the Promoter an exclusive, royalty free, perpetual, worldwide, irrevocable and sub-licensable right to use, reproduce, modify, adapt, publish and display his/her entry for any purpose in any media, without compensation, restriction on use, attribution or liability. Participants agree not to assert any moral rights in relation to such use. 
					</li>
					<li>
					Guinness Open Gate Brewery reserves the right to withdraw, terminate, temporarily suspend or amend this Competition, Prize and or these Terms and Conditions in the event of any unforeseen circumstances without notice, such as technical or other difficulties that might compromise its integrity. 
					</li>
					<li>
					Neither Guinness Open Gate Brewery nor any of its associated or affiliated companies shall accept any responsibility for difficulties, cost or expense experienced in submitting an entry to the Competition. 
					</li>
					<li>
					Neither Guinness Open Gate Brewery nor any of its associated or affiliated companies shall be liable to any entrant for any cancellation, discontinuance or delay affecting this Competition. 
					</li>
					<li>
					Neither Guinness Open Gate Brewery nor any of its associated or affiliated companies shall accept any liability for loss or damages incurred, or responsibility for any claim, as a result of acceptance of the Prize. 
					</li>
					<li>
					Dates are subject to change. 
					</li>
					<li>
					The Promoter will collect and process personal information from entrants which, by entering this Promotion, you consent to. The Promoter will only use the personal details supplied for the administration of the Promotion and for the publicity purposes referred to in clauses 16 and 17 above and for no other purpose, unless we have your consent. However, personal data supplied during the course of this Promotion may be passed on to third party suppliers only insofar as required for fulfilment/delivery/arrangement of the prize. Your personal details will at all times be kept confidential and in accordance with the EU General Data Protection Regulation (Regulation (EU) 2016/679. More details can be found on the Promoter’s privacy policy located on the Promoter’s website. 
					</li>
					<li>
					These Terms & Conditions shall be governed by and construed in accordance with the laws of the Republic of Ireland and subject to the exclusive jurisdiction of the courts of the Republic of Ireland. 
					</li>
					<li>
					This promotion is in no way sponsored, endorsed or administered by, or associated with Instagram, Facebook or any other social media platform. The information you provide will only be used for communication associated with this campaign or for further brand communication if the entrant has specifically opted in to receive this. 
					</li>
					<li>
					The full name of the winners may be obtained after the date of the draw by sending a stamped self-addressed envelope detailing your request and the name of the Promotion to: GUINNESS OPEN GATE BREWERY, JAMES'S STREET, DUBLIN 8, Ireland within 3 months of the closing date. 
					</li>
					<li>
					The Promoter takes no responsibility for any entry/claim that is lost, delayed, misdirected, corrupted or incomplete or which cannot be delivered for any technical, delivery or other reason. 
					</li>
					
				</ol>
						
				
			</div >
		)
	}
}

// 	export default connect(
//   () => ({}),
// 	{buildContentAction}
// ) (WelcomePage);
export default TermsAndConditionsPage



// WEBPACK FOOTER //
// ./src/pages/terms-and-conditions/index.js